import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import CenteredCol from './shared/CenteredCol';
import TextFit from 'react-fittext';
import { vAlignCenter } from '../style';

const styles={
    icon: {top: "6px", color: "darkgrey"},
    text: {fontSize: "1.2rem", color: "darkgrey", paddingLeft: ".5rem"}
};

const Contact = props => (
    <Row center="xs" style={{marginBottom: "2%"}}>
        <Col xs={12}>
        <h3>Contact us to get a quote on any of our servies</h3>
            <Row>
                <Col xs={12}>
                    <FontIcon className="material-icons" style={styles.icon}>phone</FontIcon>
                    <span style={styles.text}>(404) 787-9862</span>
                </Col>
                <Col xs={12}>
                    <FontIcon className="material-icons"style={styles.icon}>email</FontIcon>
                    <span style={styles.text}>vikingservices@vikingservices.co</span>
                </Col>
            </Row>
        </Col>
    </Row>
);

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js